import React from "react";
import { Menu, MenuItem } from "@mui/material";

interface CommonMenuItem {
    label: string;
    onClick: () => void;
}

interface CommonMenuProps {
    anchorEl: HTMLElement | null;
    open: boolean;
    onClose: () => void;
    items: CommonMenuItem[];
}

const CommonMenu: React.FC<CommonMenuProps> = ({
    anchorEl,
    open,
    onClose,
    items,
}) => {
    return (
        <Menu anchorEl={anchorEl} open={open} onClose={onClose}>
            {items.map((item, index) => (
                <MenuItem
                    key={index}
                    onClick={() => {
                        item.onClick();
                        onClose(); 
                    }}
                >
                    {item.label}
                </MenuItem>
            ))}
        </Menu>
    );
};

export default CommonMenu;
